import { BaseTypeSchema } from "../BaseTypeSchema";
import { VariableType } from "../VariableType";

export class PhoneSchema extends BaseTypeSchema
{
    static REGEX: RegExp = /^(\+\d{1,2}\s?)?(\d{3}[-\.\s]?)?\d{3}[-\.\s]?\d{4}$/;
    constructor(required: boolean)
    {
        super(VariableType.Phone, required);
    }
}